var React = require('react');

function ProposalsIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 0.741699H18V1.74162H22V23.7416H2V1.74162H10V0.741699ZM18 11.7417V3.74162H20V21.7416H4V3.74162H10V11.7417L14 9.7417L18 11.7417ZM12 2.7417H16V8.50563L14 7.50563L12 8.50563V2.7417ZM6.00002 13.7417H16V15.7417H6.00002V13.7417ZM14 17.7417H6.00002V19.7417H14V17.7417Z","fill":"#131416"}));
}

ProposalsIconInline.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = ProposalsIconInline;

ProposalsIconInline.default = ProposalsIconInline;
